import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { singleton, ofArray } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { desktopDataTable, mobileDataList } from "../Shared/DataList.fs.js";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { bfsCard } from "../Shared/Card.fs.js";
import * as react from "react";
import { DashboardPage } from "../DashBoardPage.fs.js";

export const columnMapping = ofArray([["SendungsNr", (row) => int32ToString(row.SendungNr)], ["Belege", (row_1) => int32ToString(row_1.AnzahlBelege)], ["Status", (row_2) => row_2.Status], ["Zeitpunkt", (row_3) => {
    let matchValue;
    return (matchValue = row_3.Zeitstempel, (matchValue == null) ? "" : asString(matchValue));
}]]);

export function mobileTable(data) {
    return mobileDataList("Keine angekaufte Belege.", columnMapping, data);
}

export function desktopTable(data) {
    return desktopDataTable("Keine angekaufte Belege.", columnMapping, data);
}

export function view(model, _arg, navigateTo) {
    let children_2;
    if (model.Loading) {
        return spinner;
    }
    else {
        return bfsCard(singleton((children_2 = [react.createElement("i", {
            className: "fas fa-angle-left mr-2",
        }), "Zurück zum Dashboard"], react.createElement("a", {
            onClick: (_arg_1) => {
                navigateTo(new DashboardPage());
            },
        }, ...children_2))), ofArray([mobileTable(model.Data), desktopTable(model.Data)]));
    }
}

//# sourceMappingURL=View.fs.js.map
